import { Box, Skeleton } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import PlaceholderImg from "../../../assets/images/placeholder/category.jpg";
import { getCategoryImageUrl } from "../../../utils/categoryProducts";

const ExploreTile = ({ category }) => {
  const background = getCategoryImageUrl(category) || PlaceholderImg;
  const tileAspect = category?.aspectRatio
    ? category.aspectRatio.replace(":", " / ")
    : undefined;

  return (
    <Link to={`/collections/${category.id}`} className="explore-card">
      <span
        className="explore-tile"
        style={tileAspect ? { aspectRatio: tileAspect } : undefined}
      >
        <Box
          className="explore-tile-bg"
          sx={{
            backgroundImage: `url(${background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <span className="explore-tile-title">{category.name}</span>
      </span>
    </Link>
  );
};

const CategoryExploreGrid = ({ categories = [], loading = false }) => {
  if (loading) {
    return (
      <Box className="explore-grid">
        {[0, 1, 2, 3].map((item) => (
          <Box key={item} className="explore-card">
            <Skeleton
              variant="rectangular"
              className="explore-tile explore-tile-skeleton"
              animation="wave"
            />
          </Box>
        ))}
      </Box>
    );
  }

  if (!categories.length) {
    return null;
  }

  return (
    <Box className="explore-grid">
      {categories.map((category) => (
        <ExploreTile key={category.id} category={category} />
      ))}
    </Box>
  );
};

export default CategoryExploreGrid;
